import { capfirst } from 'journalize';

const getDivisionDisplay = contest =>
  `${capfirst(contest.division_type)} ${(contest.division_type !==
    'statewide' &&
    contest.district) ||
    ''}`.trim();

const getContestDisplay = contest => {
  if (contest.division_type === 'statewide') {
    return contest.office;
  }

  return `${contest.office} ${getDivisionDisplay(contest)}`;
};

const getStatewideDisplay = contest => {
  if (
    contest[0].office_name === 'President' ||
    contest[0].office_name === 'U.S. Senate' ||
    contest[0].office_name === 'Railroad Commissioner'
  ) {
    return contest[0].office;
  } else if (
    contest[0].office_name === 'Chief Justice, Supreme Court of Texas'
  ) {
    return `${contest[0].office} ${contest[0].office_desc}`;
  } else {
    return `${contest[0].office} ${contest[0].label} ${contest[0].district}`;
  }
};

const createContestSlug = contest => {
  const parts = [contest.office_slug];

  if (contest.division_type !== 'statewide') {
    parts.push(`-${contest.district}`);
  }

  parts.push(`-${contest.party.slice(0, 3)}`);

  return parts.join('');
};

export function changePartyName(contest) {
  var name = contest == 'Democratic' ? 'Democrat' : 'Republican';
  return name;
}

export {
  createContestSlug,
  getContestDisplay,
  getDivisionDisplay,
  getStatewideDisplay,
};
